// Fetch

export const FETCH = 'legend.FETCH'
export const FETCH_STARTED = 'legend.FETCH_STARTED'
export const FETCH_FULFILLED = 'legend.FETCH_FULFILLED'
export const FETCH_REJECTED = 'legend.FETCH_REJECTED'
export const FETCH_CANCELLED = 'legend.FETCH_CANCELLED'
